/* src/app/system-view/main-dashboard/mini-card/mini-card-configuration/mini-card-configuration.component.scss */
.configuration-fields {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
form {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: var(--tem-space-3);
}
nz-form-item {
  width: 100%;
  margin-bottom: var(--tem-space-2);
}
.content {
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: var(--tem-fs-sm);
}
.color-input {
  padding: 2px;
  height: 32px;
  cursor: pointer;
}
.more-options {
  padding: var(--tem-space-1) var(--tem-space-3);
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: var(--tem-space-4);
  align-items: center;
}
.switch-option {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
  cursor: pointer;
  color: var(--tem-ink);
}
/*# sourceMappingURL=mini-card-configuration.component.css.map */
